"use strict";

angular.module("core")
.component("tagFilter", {
    bindings: {
        filter: "<?",
        service: "<",
        displayAsList: "<?"
    },
    templateUrl: require("./tag-filter.component.html"),
    controllerAs: "tagFilterCtrl",
    controller: function($scope, $state, $stateParams, ConvertToParameterService) {
        var _this = this;
        $scope.displayAsList = this.displayAsList;

        this.MAX_TAGS_DISPLAYED = 16;
        this.hideAllTags = true;
        this.selectedTags = {};

        this.service.query(this.filter).$promise.then(function(tagFilters) {
            _this.tagFilters = tagFilters;
            $scope.displayMoreButton = _this.tagFilters.length && _this.tagFilters.length > _this.MAX_TAGS_DISPLAYED;

            var tagParams = [];
            if ($stateParams.tags) {
                tagParams = $stateParams.tags.split(",");
            }

            angular.forEach(tagFilters, function(value, key) {
                _this.selectedTags[key] = {
                    "selected": tagParams.indexOf(value) >= 0,
                    "tag": value
                };
            });
        });

        this.updateTagsFilter = function() {
            var selectedTags = ConvertToParameterService.convertTagsToParameter(this.selectedTags);
            $scope.$emit("tagFilterUpdated", {tags: selectedTags});
        };

        this.toggleTags = function() {
            this.hideAllTags = !this.hideAllTags;
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/tag-filter/tag-filter.component.js
// module id = 604
// module chunks = 0